@if (visible()) {
  <div
    class="relative w-full rounded-lg border border-border-common-base bg-white p-4 text-text-common-base"
  >
    <p-button
      class="absolute right-2 top-2"
      variant="text"
      severity="contrast"
      size="small"
      pTooltip="Close"
      tooltipPosition="left"
      (onClick)="dismiss()"
    >
      <ng-template #icon>
        <svg-icon src="/assets/icons/general/close.svg" />
      </ng-template>
    </p-button>
    <ng-content />
  </div>
}
